import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";

/**
 * Props for `Partners`.
 */
export type PartnersProps = SliceComponentProps<Content.PartnersSlice>;

/**
 * Component for "Partners" Slices.
 */
const Partners: FC<PartnersProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className="px-4 md:px-8 lg:px-12 2xl:px-0 font-fellix mb-12"
    >
      <div className="w-full max-w-[1280px] mx-auto">
        {slice.primary.title ? 
        <article className="text-[28px] leading-[36px] pb-8 font-semibold ">
          <PrismicRichText field={slice.primary.title}/>
        </article>
        : null }
          <div className="grid grid-cols-12 gap-0 md:gap-8">
            {slice.primary.partners.map((item: any, index:number)=>{
                return (
                  <div className="col-span-12 md:col-span-4" key={index}>
                      <PrismicNextImage field={item.logo} fallbackAlt="" className="w-full object-cover aspect-video mb-4" />
                      <p className="text-lg leading-[26px] font-normal">{item.name}</p>
                      <p className="text-lg leading-[26px] font-normal text-black/50 mb-4">{item.description}</p>
                  </div>
                )
            })}
          </div>
      </div>
    </section>
  );
};

export default Partners;
